export const departmentsArr = [
  'Аліса',
  'Артема',
  'Воронцова',
  'Головна',
  'Донецька',
  'Екстернат',
  'Калинова',
  'Комунар',
  'Ламана',
  'Оболонь',
  'Осокорки',
  'Паторжинського',
  'Правда',
  'Робоча',
  'Таїрова',
  'Теремки',
  'Титова',
  'Тополя',
  'Черемушки',
];
